import moment from "moment";
import { Fragment } from "react";
import { useSelector } from "react-redux";

import CalendarDaysOfWeek from "./CalendarDaysOfWeek";
import MonthCalendarSchedules from "./MonthCalendarSchedules";
import MonthCalendarSchedulesManagement from "./MonthCalendarSchedulesManagement";

const MonthCalendar = ({ calendarObj }) => {
  const { user } = useSelector((state) => state.userReducer);
  const { selectedStart } = useSelector((state) => state.calendarReducer);
  const { schedules, atualDate, onDateClick, onSchedulesClick, onScheduleClick } = calendarObj;

  const monthStart = moment(selectedStart).clone().startOf("month");
  const monthEnd = moment(selectedStart).clone().endOf("month");
  const startDate = monthStart.clone().startOf("week");
  const endDate = monthEnd.clone().endOf("week");

  const rows = [];
  let days = [];
  let day = startDate;
  while (day <= endDate) {
    for (let i = 0; i < 7; i++) {
      const daySchedules = schedules
        ?.filter((item) => item.scheduledDate === day.format("YYYY-MM-DD"))
        .sort((a, b) => {
          if (a.status > b.status) return -1;
          if (a.status < b.status) return 1;
          return 0;
        });
      const isSameMonth = day.isSame(selectedStart, "month");
      const isSameDay = day.isSame(atualDate, "day");
      const targetDay = day.clone();
      days.push(
        <div
          key={day + i}
          className={`monthDay ${!isSameMonth ? "disabled" : isSameDay ? "selected" : ""}`}
          onClick={() => onDateClick(targetDay)}
        >
          <p className="calendarDay">{day.format("DD")}</p>
          {user?.role === "student" || user?.role === "teacher" ? (
            <MonthCalendarSchedules
              daySchedules={daySchedules}
              onScheduleClick={onScheduleClick}
              targetDay={targetDay}
            />
          ) : (
            <MonthCalendarSchedulesManagement
              daySchedules={daySchedules}
              onSchedulesClick={onSchedulesClick}
              targetDay={targetDay}
            />
          )}
        </div>,
      );
      day.add(1, "day");
    }
    rows.push(
      <div className="monthWeekBox" key={day.format("DD/MM/YYYY")}>
        {days}
      </div>,
    );
    days = [];
  }
  return (
    <Fragment>
      <CalendarDaysOfWeek calendarObj={calendarObj} />
      <div className="monthBox">{rows}</div>
    </Fragment>
  );
};

export default MonthCalendar;
